import { render, staticRenderFns } from "./NewSaasBanner.vue?vue&type=template&id=0ed9d7be&scoped=true&"
import script from "./NewSaasBanner.vue?vue&type=script&lang=js&"
export * from "./NewSaasBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewSaasBanner.vue?vue&type=style&index=0&id=0ed9d7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9d7be",
  null
  
)

export default component.exports